import React from 'react';
import iPhoneNewShifts from '../assets/images/iphone-new-shift.png';
import iPhoneFeedback from '../assets/images/iphone-feedback.png';
import iPhoneText from '../assets/images/iphone-text.png';


function HowItWorksScreenshots(props) {
  return (
    <div id="how-it-works" className="how-it-works">
      <div className="step step-odd">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <p className="step-number text-uppercase"><strong>Step 1</strong></p>
              <h2>Post a shift in seconds</h2>
              <p>Answer a few basic questions, set the hourly wage and you're ready to post your shift to SingleShift.</p>
            </div>
            <div className="col-md-6">
              <img className="img-fluid" src={iPhoneNewShifts} />
            </div>
          </div>
        </div>
      </div>
      <div className="step step-even">
        <div className="container">
          <div className="row flex-md-row-reverse align-items-center">
            <div className="col-md-6">
              <p className="step-number text-uppercase"><strong>Step 2</strong></p>
              <h2>Reach hundreds of qualified Pros instantly</h2>
              <p>Your shift is instantly sent to hundreds of Pros through SMS. SingleShift handles the responses and notifies you when a Pro has accepted the shift.</p>
            </div>
            <div className="col-md-6">
              <img className="img-fluid" src={iPhoneText} />
            </div>
          </div>
        </div>
      </div>
      <div className="step step-odd">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <p className="step-number text-uppercase"><strong>Step 3</strong></p>
              <h2>Give feedback</h2>
              <p>SingleShift takes the reliability and quality of our Pros seriously. Pros are manually screened before they're allowed to work and rated after every shift.</p>
            </div>
            <div className="col-md-6">
              <img className="img-fluid" src={iPhoneFeedback} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HowItWorksScreenshots;



// WEBPACK FOOTER //
// ./src/parts/HowItWorksScreenshots.js